import React, { Component } from 'react';
import { FiHeadphones, FiThumbsUp } from 'react-icons/fi'
import { FaCogs } from 'react-icons/fa'

class HowItWork4 extends Component {
    state = {
        items: [
            {
                icon: <FiHeadphones />,
                title: 'دعم 24/7 ساعة',
                desc: 'هناك العديد من الأنواع المتوفرة لنصوص لوريم إيبسوم. عيني أ من الحزن وأطراف الأرض'
            },
            {
                icon: <FaCogs />,
                title: 'لوحة الادارة',
                desc: 'هناك العديد من الأنواع المتوفرة لنصوص لوريم إيبسوم. عيني أ من الحزن وأطراف الأرض'
            },
            {
                icon: <FiThumbsUp />,
                title: 'متوافق مع الجوال',
                desc: 'هناك العديد من الأنواع المتوفرة لنصوص لوريم إيبسوم. عيني أ من الحزن وأطراف الأرض'
            }
        ]
    }
    render() {
        return (
            <>
                {this.state.items.map((item, i) => {
                    return (
                        <div className="col-lg-4 column-td-6" key={i}>
                            <div className="icon-box icon-box-layout icon-box-layout-3">
                                <div className="info-icon section-bg-3 text-white">
                                    <span className="la">{item.icon}</span>
                                </div>
                                <div className="info-content">
                                    <h4 className="info__title">
                                        {item.title}
                                    </h4>
                                    <p className="info__desc">
                                        {item.desc}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </>
        );
    }
}

export default HowItWork4;